import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * Initialize GSAP-based in-view animations for elements with the `op-inview` attribute.
 */
export default function inView() {
    // Select elements that haven't been initialized yet
    const elements = document.querySelectorAll('[op-inview]:not(.gsap-initialized)');

    elements.forEach(element => {
        // Mark as initialized to avoid duplicate setups
        element.classList.add('gsap-initialized');

        // Parse custom thresholds from the `op-inview` attribute
        const settings = element.getAttribute('op-inview') || '';
        const [startThreshold = 0.2, endThreshold = 0.8, delay = 0] = settings
          .split(',')
          .map(Number);

        const start = `${startThreshold * 100}% bottom`;
        const end = `${endThreshold * 100}% top`;

        // Create GSAP ScrollTrigger for the element
        gsap.from(element, {
          scrollTrigger: {
            trigger: element,
            start,
            end,
            toggleClass: 'is-inview',
            once: true, // Trigger only once
            toggleActions: "play none none none",
            delay: 1,
            /*
            onEnter: () => {
              if (delay) {
                gsap.delayedCall(delay / 1000, () => {
                  element.classList.add('is-inview');
                });
              }
            },
            onLeaveBack: () => {
              if (element.hasAttribute('op-inview-deactivate')) {
                element.classList.remove('is-inview');
              }
            },
            */
            onRefresh: () => {
              if (isElementInViewport(element)) {
                setTimeout(() => {
                  element.classList.add('is-inview');
                }, 2000);
              }
            }
          }
        });
    });

    // Helper function to check if an element is in the viewport
    function isElementInViewport(el) {
      const rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }
}
